import { trackCustomEvent } from '@/utils/analytics'
import { reportWebFunnelEvent } from '@/utils/clientEventLog'
import { generateEventId } from '@/utils/eventTracking'

export function trackCartView(surface, itemCount) {
  if (!process.client)
    return

  const eventId = generateEventId('cart_view')
  reportWebFunnelEvent('view_cart', { eventId, surface, itemCount })
  trackCustomEvent('ViewCart', {
    eventId,
    parameters: {
      surface,
      item_count: itemCount,
    },
  })
}
